export default __webpack_public_path__ + "static/media/google.154ddb64.svg";